import getViewFilterForTable from 'mini-mail-list-store/lib/utils/getViewFilterForTable';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { getPropsForViewFilter, ViewFilterProps } from './getPropsForViewFilter';

interface ActiveMailListFilterProps extends ViewFilterProps {
    activeViewFilter: ViewFilter;
}

export const getActiveMailListFilterPropsForSelectedView = (
    selectedTableView: TableView
): ActiveMailListFilterProps => {
    const activeViewFilter: ViewFilter = selectedTableView
        ? getViewFilterForTable(selectedTableView)
        : 'All';

    return { ...getPropsForViewFilter(activeViewFilter), activeViewFilter };
};
